import { render, staticRenderFns } from "./ExportMenus.vue?vue&type=template&id=281fc873&"
import script from "./ExportMenus.vue?vue&type=script&lang=js&"
export * from "./ExportMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports